import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { AmountTotal } from 'services/api/dashboard';
import { toUpperCase } from 'utils/toLowerCase';
import { useCallback } from 'react';
import { formatNumber } from 'utils/numberFormat';

const findValue = (regionCode: string, totalList?: AmountTotal[]) => {
  return totalList?.find((i) => i.region === regionCode);
};

/**
 * 活动效果金额根据系统语言显示对应货币
 */
export const useCurrencyTotalDisplay = () => {
  const lng = useSystemLanguageValue();

  return useCallback(
    (totalList: AmountTotal[]) => {
      if (lng === 'zh-CN') {
        return findValue('CN', totalList);
      }
      if (lng === 'en-US') {
        return findValue('US', totalList);
      }
      if (lng === 'vi') {
        return findValue('VN', totalList);
      }
      if (lng === 'pt') {
        return findValue('BR', totalList);
      }
      if (lng === 'tl') {
        return findValue('PH', totalList);
      }
      return findValue(toUpperCase(lng), totalList);
    },
    [lng],
  );
};

export const useCurrencyTotalFormat = () => {
  const getCurrencyTotalDisplay = useCurrencyTotalDisplay();

  return useCallback(
    (totalList: AmountTotal[]) => {
      const amount = getCurrencyTotalDisplay(totalList);
      return amount ? `${amount.unit}${formatNumber(amount.amount, '0,0.00')}` : '-';
    },
    [getCurrencyTotalDisplay],
  );
};
